export default [
    {
        label: "json",
        value: "json",
    },
    {
        label: "form_(only_post)",
        value: "form",
    },
]